import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'outlets',
        loadChildren: './outlets/outlets.module#OutletsModule'
      },
      {
        path: 'orders',
        loadChildren: './orders/orders.module#OrdersModule'
      },
      {
        path: 'catalog',
        loadChildren: './catalog/catalog.module#CatalogModule'
      },

      {
        path: 'users',
        loadChildren: './users/users.module#UsersModule'
      },
      {
        path: 'depot',
        loadChildren: './hierarchy/depo.module#DepoModule'
      },
      {
        path: 'area',
        loadChildren: './hierarchy/area.module#AreaModule'
      },
      {
        path: 'payments',
        loadChildren: './payments/payments.module#PaymentsModule'
      },
      {
        path: 'town',
        loadChildren: './hierarchy/town.module#TownModule'
      }
    ]
  },
  {
    path: 'pages',
    component: SimpleLayoutComponent,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    { enableTracing: true } // <-- debugging purposes only
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts